const IF = require( "infrontjs" );

import { InAppState } from "../base/InAppState";

import template from './AccountTemplate.html';

export class AccountState extends InAppState
{
    static ROUTE = '/account';
    static ID = 'account';

    async enter()
    {
        this.app.container.innerHTML = this.app.view.getHtml(
            template,
            {
                currentUser: this.app.currentUser
            }
        );

        this.app.container.querySelector( '[data-id="btnChangeName"]' ).addEventListener( 'click', async () =>
        {
            const form = this.app.container.querySelector( '[data-id="formName"]' );
            form.classList.add( 'was-validated' );
            if ( true === form.checkValidity() )
            {
                const formData = IF.Helper.serializeForm( form );
                if ( formData.newName === this.app.currentUser.get( 'name' ) )
                {
                    return true;
                }
                const result = await this.app.api.patch( '/user/name', formData );
                if ( result && 200 === result.status )
                {
                    window.location.reload();
                }
                else
                {
                    this.app.gui.showSnackbarError( 'Name konnte nicht aktualisiert werden.' );
                }
            }
        });
        this.app.container.querySelector( '[data-id="btnChangePassword"]' ).addEventListener( 'click', async () =>
        {
            const form = this.app.container.querySelector( '[data-id="formPassword"]' );
            form.classList.add( 'was-validated' );
            if ( true === form.checkValidity() )
            {
                const formData = IF.Helper.serializeForm( form );
                const result = await this.app.api.patch( '/user/password', formData );
                if ( result && 200 === result.status )
                {
                    this.app.gui.showSnackbarConfirmed( 'Passwort erfolgreich aktualisiert.' );
                    form.classList.remove( 'was-validated' );
                    form.reset();
                }
                else if ( result && 403 === result.status )
                {
                    this.app.gui.showSnackbarError( 'Fehlerhaftes bisheriges Passwort.' );
                }
                else
                {
                    this.app.gui.showSnackbarError( 'Passwort konnte nicht aktualisiert werden.' );
                }
            }
        });
    }

    async exit()
    {
    }
};
